<script lang="ts">
import Vue from 'vue'
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';
import LandingPromoCodes from "@/views/partners/LandingPromoCodes.vue";

export default Vue.extend({
    name: "PromoCodes",
    components: {
        LandingPromoCodes,
        Breadcrumbs,
        PageLayout,
        PageTitle
    }
})
</script>

<template>
<div>
    <PageLayout>
        <PageTitle class="page-title">{{ $route.meta.title }}</PageTitle>
        <Breadcrumbs/>
        <div class="history-order__wrapp mt-4">
            <div class="history-order__item">
                <LandingPromoCodes :partner-id="Number($route.params.id)"/>
            </div>
        </div>
    </PageLayout>
</div>
</template>

<style scoped lang="scss">

</style>
